<template class="favorites">
    <h1>Favorites</h1>
</template>